const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      resolve(image)
    }
    image.onabort = image.onerror = () => {
      reject(`Image ${src} could not be loaded`)
    }
    image.src = src
  })

export default loadImage
